export type YieldbirdStatus = (typeof yieldbirdStatuses)[number]

export const yieldbirdStatuses = ['available', 'requested', 'denied'] as const
